// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__2hym0","footerInner":"style_footerInner__1DuHA","logo":"style_logo__2d2sM"};